import React, { useState, useEffect } from 'react'
import { Calendar, ChevronDown } from 'lucide-react'
import DetalleProductoModal from './DetalleProductoModal'

export default function PrediccionDiaria({ deliveries }) {
  const [fechaSeleccionada, setFechaSeleccionada] = useState('')
  const [fechasSugeridas, setFechasSugeridas] = useState([])
  const [datosDia, setDatosDia] = useState(null)
  const [historico7Dias, setHistorico7Dias] = useState([])
  const [mostrarSelector, setMostrarSelector] = useState(false)
  const [mostrarCalendario, setMostrarCalendario] = useState(false)
  const [fechaBuscada, setFechaBuscada] = useState('')
  
  // Modal detalle
  const [modalDetalle, setModalDetalle] = useState(null)

  const diasSemana = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado']

  useEffect(() => {
    calcularFechasSugeridas()
  }, [])

  useEffect(() => {
    if (fechaSeleccionada && deliveries) {
      procesarDatosDia()
      procesarHistorico7Dias()
    }
  }, [fechaSeleccionada, deliveries])

  function calcularFechasSugeridas() {
    const hoy = new Date()
    const mañana = new Date(hoy)
    mañana.setDate(mañana.getDate() + 1)
    
    const diaMañana = mañana.getDay()
    
    // Generar últimas 4 fechas del mismo día de la semana
    const sugeridas = []
    for (let i = 1; i <= 4; i++) {
      const fecha = new Date(mañana)
      fecha.setDate(mañana.getDate() - (7 * i))
      sugeridas.push({
        fecha: fecha.toISOString().split('T')[0],
        label: fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' }),
        diasAtras: 7 * i,
        esAutomatico: i === 1
      })
    }
    
    setFechasSugeridas(sugeridas)
    setFechaSeleccionada(sugeridas[0].fecha) // Por defecto: hace 7 días
  }

  function procesarDatosDia() {
    const deliveriesDia = deliveries.filter(d => d.fecha === fechaSeleccionada)
    
    if (deliveriesDia.length === 0) {
      setDatosDia({ productos: [], total: { entregado: 0, devuelto: 0 } })
      return
    }

    const productoStats = {}
    
    deliveriesDia.forEach(delivery => {
      delivery.delivery_lines?.forEach(line => {
        const productoNombre = line.products?.nombre || 'Desconocido'
        const clienteNombre = delivery.clients?.alias || delivery.clients?.razon_social || 'Desconocido'
        
        if (!productoStats[productoNombre]) {
          productoStats[productoNombre] = {
            nombre: productoNombre,
            entregado: 0,
            devuelto: 0,
            clientes: []
          }
        }
        
        const entregado = line.cantidad_entregada || 0
        const devuelto = line.cantidad_devuelta || 0
        
        productoStats[productoNombre].entregado += entregado
        productoStats[productoNombre].devuelto += devuelto
        
        if (entregado > 0) {
          productoStats[productoNombre].clientes.push({
            nombre: clienteNombre,
            entregado: entregado,
            devuelto: devuelto,
            porcentajeDev: entregado > 0 ? ((devuelto / entregado) * 100).toFixed(1) : '0.0'
          })
        }
      })
    })

    // Procesar devoluciones del día siguiente (ajuste temporal)
    const fechaSiguiente = new Date(fechaSeleccionada + 'T00:00:00')
    fechaSiguiente.setDate(fechaSiguiente.getDate() + 1)
    const fechaSigStr = fechaSiguiente.toISOString().split('T')[0]
    
    const deliveriesSiguiente = deliveries.filter(d => d.fecha === fechaSigStr)
    deliveriesSiguiente.forEach(delivery => {
      delivery.delivery_lines?.forEach(line => {
        const productoNombre = line.products?.nombre || 'Desconocido'
        const devuelto = line.cantidad_devuelta || 0
        
        if (productoStats[productoNombre] && devuelto > 0) {
          // Ya contamos las devoluciones en el día siguiente, no duplicar
          // Las devoluciones ya están en delivery_lines del día seleccionado
        }
      })
    })

    const productosArray = Object.values(productoStats).map(p => ({
      ...p,
      neto: p.entregado - p.devuelto,
      porcentajeDev: p.entregado > 0 ? ((p.devuelto / p.entregado) * 100).toFixed(1) : '0.0',
      sugerencia: Math.ceil((p.entregado - p.devuelto) * 1.05) // Neto + 5%
    })).sort((a, b) => b.entregado - a.entregado)

    const total = {
      entregado: productosArray.reduce((sum, p) => sum + p.entregado, 0),
      devuelto: productosArray.reduce((sum, p) => sum + p.devuelto, 0)
    }

    setDatosDia({ productos: productosArray, total })
  }

  function procesarHistorico7Dias() {
    const hoy = new Date()
    const hace7Dias = new Date(hoy)
    hace7Dias.setDate(hoy.getDate() - 7)

    const fechas = []
    for (let i = 0; i < 7; i++) {
      const fecha = new Date(hace7Dias)
      fecha.setDate(hace7Dias.getDate() + i)
      fechas.push(fecha.toISOString().split('T')[0])
    }

    const productosPorDia = {}

    fechas.forEach(fecha => {
      const deliveriesDia = deliveries.filter(d => d.fecha === fecha)
      
      deliveriesDia.forEach(delivery => {
        delivery.delivery_lines?.forEach(line => {
          const productoNombre = line.products?.nombre || 'Desconocido'
          const clienteNombre = delivery.clients?.alias || delivery.clients?.razon_social || 'Desconocido'
          
          if (!productosPorDia[productoNombre]) {
            productosPorDia[productoNombre] = {}
          }
          
          if (!productosPorDia[productoNombre][fecha]) {
            productosPorDia[productoNombre][fecha] = {
              entregado: 0,
              devuelto: 0,
              clientes: []
            }
          }
          
          const entregado = line.cantidad_entregada || 0
          const devuelto = line.cantidad_devuelta || 0
          
          productosPorDia[productoNombre][fecha].entregado += entregado
          productosPorDia[productoNombre][fecha].devuelto += devuelto
          
          if (entregado > 0) {
            productosPorDia[productoNombre][fecha].clientes.push({
              nombre: clienteNombre,
              entregado: entregado,
              devuelto: devuelto,
              porcentajeDev: entregado > 0 ? ((devuelto / entregado) * 100).toFixed(1) : '0.0'
            })
          }
        })
      })
    })

    const historico = Object.entries(productosPorDia).map(([producto, dias]) => ({
      producto,
      dias: fechas.map(fecha => {
        const dato = dias[fecha] || { entregado: 0, devuelto: 0, clientes: [] }
        const porcentaje = dato.entregado > 0 
          ? ((dato.devuelto / dato.entregado) * 100).toFixed(1) 
          : '0.0'
        return {
          fecha,
          entregado: dato.entregado,
          devuelto: dato.devuelto,
          porcentaje,
          clientes: dato.clientes,
          color: parseFloat(porcentaje) > 12 ? '🔴' : parseFloat(porcentaje) > 8 ? '🟡' : '🟢'
        }
      })
    }))

    setHistorico7Dias(historico)
  }

  function buscarFecha() {
    if (!fechaBuscada) return
    setFechaSeleccionada(fechaBuscada)
    setMostrarCalendario(false)
    setMostrarSelector(false)
  }

  function abrirDetalleProducto(producto, fecha, datosClientes) {
    setModalDetalle({
      producto,
      fecha,
      datosClientes
    })
  }

  const mañana = new Date()
  mañana.setDate(mañana.getDate() + 1)
  const nombreMañana = mañana.toLocaleDateString('es-ES', { 
    weekday: 'long', 
    day: 'numeric', 
    month: 'long' 
  })

  const fechaSeleccionadaObj = fechasSugeridas.find(f => f.fecha === fechaSeleccionada)

  return (
    <div>
      {/* PREDICCIÓN PARA MAÑANA */}
      <div className="card" style={{ padding: '1.5rem', marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Calendar size={20} />
          📅 ¿Qué producir mañana? - {nombreMañana}
        </h3>

        {/* Selector de fecha */}
        <div style={{ marginBottom: '1.5rem', position: 'relative' }}>
          <div style={{ fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.5rem' }}>
            Basándote en:
          </div>
          <button
            onClick={() => setMostrarSelector(!mostrarSelector)}
            style={{
              width: '100%',
              padding: '0.75rem',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: 'var(--fg)',
              fontSize: '1rem'
            }}
          >
            <span>
              {fechaSeleccionadaObj?.esAutomatico && '⭐ '}
              {fechaSeleccionadaObj?.label} 
              {fechaSeleccionadaObj && ` (hace ${fechaSeleccionadaObj.diasAtras} días)`}
            </span>
            <ChevronDown size={20} />
          </button>

          {/* Dropdown */}
          {mostrarSelector && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              marginTop: '0.5rem',
              background: 'var(--bg)',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              zIndex: 10,
              maxHeight: '300px',
              overflow: 'auto'
            }}>
              {fechasSugeridas.map((fecha, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setFechaSeleccionada(fecha.fecha)
                    setMostrarSelector(false)
                  }}
                  style={{
                    padding: '0.75rem 1rem',
                    cursor: 'pointer',
                    borderBottom: idx < fechasSugeridas.length - 1 ? '1px solid var(--border)' : 'none',
                    background: fecha.fecha === fechaSeleccionada ? 'var(--bg-secondary)' : 'transparent'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'var(--bg-secondary)'}
                  onMouseLeave={(e) => {
                    if (fecha.fecha !== fechaSeleccionada) {
                      e.currentTarget.style.background = 'transparent'
                    }
                  }}
                >
                  {fecha.esAutomatico && '⭐ '}
                  {fecha.label} (hace {fecha.diasAtras} días)
                </div>
              ))}
              
              <div
                onClick={() => {
                  setMostrarCalendario(true)
                  setMostrarSelector(false)
                }}
                style={{
                  padding: '0.75rem 1rem',
                  cursor: 'pointer',
                  borderTop: '1px solid var(--border)',
                  fontWeight: 'bold',
                  color: 'var(--accent)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--bg-secondary)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                📅 Buscar otra fecha...
              </div>
            </div>
          )}
        </div>

        {/* Calendario personalizado */}
        {mostrarCalendario && (
          <div style={{
            marginBottom: '1rem',
            padding: '1rem',
            background: 'var(--bg-secondary)',
            borderRadius: '8px'
          }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
              Seleccionar fecha específica:
            </label>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <input
                type="date"
                value={fechaBuscada}
                onChange={(e) => setFechaBuscada(e.target.value)}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  borderRadius: '6px',
                  border: '1px solid var(--border)',
                  background: 'var(--bg)',
                  color: 'var(--fg)'
                }}
              />
              <button onClick={buscarFecha} className="btn-primary">
                Buscar
              </button>
              <button 
                onClick={() => setMostrarCalendario(false)} 
                className="btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tabla de predicción */}
        {datosDia && datosDia.productos.length > 0 ? (
          <div className="tabla-wrapper">
            <table className="tabla-lineas">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th style={{ textAlign: 'right' }}>Entregado</th>
                  <th style={{ textAlign: 'right' }}>Sobró</th>
                  <th style={{ textAlign: 'right' }}>Neto</th>
                  <th style={{ textAlign: 'right' }}>💡 Sugerencia</th>
                </tr>
              </thead>
              <tbody>
                {datosDia.productos.map((producto, idx) => (
                  <tr 
                    key={idx}
                    onClick={() => abrirDetalleProducto(producto.nombre, fechaSeleccionada, producto.clientes)}
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--bg-secondary)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <td style={{ fontWeight: 500 }}>
                      {producto.nombre} 👁️
                    </td>
                    <td style={{ textAlign: 'right' }}>{producto.entregado} ud</td>
                    <td style={{ textAlign: 'right', color: 'var(--warn)' }}>
                      {producto.devuelto} ud
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {producto.neto} ud
                    </td>
                    <td style={{ 
                      textAlign: 'right', 
                      fontSize: '1.125rem',
                      fontWeight: 'bold',
                      color: 'var(--accent)'
                    }}>
                      {producto.sugerencia} ud
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--muted)' }}>
            No hay datos para la fecha seleccionada
          </div>
        )}

        <div style={{ 
          marginTop: '1rem', 
          fontSize: '0.875rem', 
          color: 'var(--muted)',
          textAlign: 'center'
        }}>
          💡 Sugerencia = Neto + 5% de margen de seguridad
        </div>
      </div>

      {/* HISTÓRICO 7 DÍAS */}
      <div className="card" style={{ padding: '1.5rem', marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>
          📊 Histórico Últimos 7 Días
        </h3>
        <div style={{ fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '1rem' }}>
          Click en cualquier celda para ver detalle de clientes
        </div>

        {historico7Dias.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              fontSize: '0.875rem'
            }}>
              <thead>
                <tr style={{ background: 'var(--bg-secondary)' }}>
                  <th style={{ 
                    padding: '0.75rem', 
                    textAlign: 'left',
                    position: 'sticky',
                    left: 0,
                    background: 'var(--bg-secondary)',
                    zIndex: 1
                  }}>
                    Producto
                  </th>
                  {historico7Dias[0]?.dias.map((dia, idx) => {
                    const fecha = new Date(dia.fecha + 'T00:00:00')
                    return (
                      <th key={idx} style={{ 
                        padding: '0.75rem', 
                        textAlign: 'center',
                        minWidth: '80px'
                      }}>
                        <div>{diasSemana[fecha.getDay()].slice(0, 3)}</div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--muted)' }}>
                          {fecha.getDate()}/{fecha.getMonth() + 1}
                        </div>
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {historico7Dias.map((producto, pidx) => (
                  <React.Fragment key={pidx}>
                    <tr style={{ background: 'var(--bg-secondary)' }}>
                      <td 
                        style={{ 
                          padding: '0.5rem 0.75rem',
                          fontWeight: 'bold',
                          position: 'sticky',
                          left: 0,
                          background: 'var(--bg-secondary)',
                          zIndex: 1
                        }}
                        rowSpan={3}
                      >
                        {producto.producto}
                      </td>
                      {producto.dias.map((dia, didx) => (
                        <td 
                          key={didx}
                          onClick={() => abrirDetalleProducto(producto.producto, dia.fecha, dia.clientes)}
                          style={{ 
                            padding: '0.5rem', 
                            textAlign: 'center',
                            cursor: 'pointer',
                            borderBottom: '1px solid var(--border)'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          {dia.entregado}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      {producto.dias.map((dia, didx) => (
                        <td 
                          key={didx}
                          onClick={() => abrirDetalleProducto(producto.producto, dia.fecha, dia.clientes)}
                          style={{ 
                            padding: '0.5rem', 
                            textAlign: 'center',
                            color: 'var(--warn)',
                            fontSize: '0.75rem',
                            cursor: 'pointer',
                            borderBottom: '1px solid var(--border)'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          -{dia.devuelto}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      {producto.dias.map((dia, didx) => (
                        <td 
                          key={didx}
                          onClick={() => abrirDetalleProducto(producto.producto, dia.fecha, dia.clientes)}
                          style={{ 
                            padding: '0.5rem', 
                            textAlign: 'center',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            borderBottom: pidx < historico7Dias.length - 1 ? '2px solid var(--border)' : 'none'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          {dia.color} {dia.porcentaje}%
                        </td>
                      ))}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--muted)' }}>
            No hay datos históricos
          </div>
        )}

        <div style={{ 
          marginTop: '1rem', 
          fontSize: '0.75rem', 
          color: 'var(--muted)',
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center'
        }}>
          <span>🟢 {'<'} 8% dev</span>
          <span>🟡 8-12% dev</span>
          <span>🔴 {'>'} 12% dev</span>
        </div>
      </div>

      {/* Modal detalle producto */}
      {modalDetalle && (
        <DetalleProductoModal
          producto={modalDetalle.producto}
          fecha={modalDetalle.fecha}
          datosClientes={modalDetalle.datosClientes}
          onClose={() => setModalDetalle(null)}
        />
      )}
    </div>
  )
}